import apiEndpoints from '../constants/apiEndPoints/authentication';
import { apiHeader } from '../constants/apiHeader';
import { post } from './apiService';

export const forgotPasswordAuthentication = async <T>(data: T) => {
  return post(apiEndpoints.FORGOT_PASSWORD, data, apiHeader.APPLICATION_JSON);
};
